export enum CssLayoutUnits {
    // Screen units
    px = "px", // Pixels
    em = "em", // Font size
    ex = "ex", // Rarely used -- is related to x-height of a font.
    rem = "rem",

    // Print Units
    cm = "cm",
    in = "in",
    pt = "pt",

    // Screen and print
    percent = "%"
}

// Convert the units type to a CSS string
function cssLayoutUnitsText(units: CssLayoutUnits): string | undefined {
    return units?.toString();
}

export interface ICssLength
{
    amount: number,
    units: CssLayoutUnits
}

// Convert a CSS length to the CSS text used for the value
export function cssValue(cssLen?: ICssLength): string|undefined
{
    if (!cssLen)
        return;
    return `${cssLen.amount}${cssLayoutUnitsText(cssLen.units)}`;
}

export class CssLength implements ICssLength {
    amount: number = 1;
    units: CssLayoutUnits = CssLayoutUnits.em;

    constructor(amount: number, units?: CssLayoutUnits){
        this.amount = amount;
        this.units = units ?? CssLayoutUnits.em;
    }

    get cssValue(): string{
        return cssValue(this) ?? "";
    }

    public static em(amount: number){
        return new CssLength(amount, CssLayoutUnits.em);
    }

    public static px(amount: number){
        return new CssLength(amount, CssLayoutUnits.px);
    }

    public static percent(amount: number){
        return new CssLength(amount, CssLayoutUnits.percent);
    }

    public static hasCssLength(object: any): boolean{
        return ("amount" in object && "units" in object);
    }
}

